export default __webpack_public_path__ + "a7f0e4444be9b1a772e3cb0fc546291e.svg";